import {
  put,
  select
} from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';
import packageJson from '../../../package.json';


export function* initConnectivitySaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
  yield put(actions.initConnectivityStart());
  try {
    let response = {};
        response = yield axios.post(
          '/connectivity',
          { rMac:rMac,
            bToken: token,
            sessionToken:sessionToken }
        ).then(res=>{
          // console.log('is res', res.data)
          let parsedData = JSON.parse(res.data.data)
          // console.log('connectivity parsed data', parsedData)
          // sessionStorage.setItem("vendorModel", parsedData.model);
          return parsedData

        })
    yield //console.log('gonna set conn', response.status)
    yield put(actions.setConnectivity(response.status));

    // WIN-1702: reconcile router-level suspension into tenantData for the banners.
    yield* reconcileTenantSuspension(response.status);
  } catch (error) {
    yield put(actions.fetchConnectivityFailed());
  }
} else {
  //console.log('NO TOKEN')
 }

}

/* WIN-1702: When WIN is launched directly for a suspended tenant, the CREST single-tenant
 * lookup cannot always resolve a suspended connectionStatus (a tenant-scoped account
 * returns no bulk tenant match), so wan.tenantData never reports the suspension the
 * Overview/Network banners require. For non-SpecReady tenants, suspension is enforced at
 * the router (enablement === "noService"). This reconciles that router-level state into
 * tenantData without overriding a real suspended value from the bulk PSP path. It is
 * driven both from initConnectivitySaga (connectivity resolves first) and from a watcher
 * on SET_TENANT (bulk tenantData arrives last and would otherwise clobber the value), so
 * it is correct regardless of which request finishes first. PSP launches already carry a
 * suspended connectionStatus, so this is a no-op for them.
 */
function* reconcileTenantSuspension(connectivityStatus) {
  const type = yield sessionStorage.getItem('type');
  const subclass = yield sessionStorage.getItem('subclass');
  const isTenant = subclass === 'TENANT' && type && type.includes('Tenant');
  if (!isTenant || connectivityStatus !== 'noService') {
    return;
  }

  const tenantData = yield select(state => state.wan.tenantData);
  const alreadySuspended =
    ['SUSPENDED', 'OFFLINE_SUSPENDED'].includes(tenantData?.connectionStatus) ||
    ['SUSPENDED', 'OFFLINE_SUSPENDED'].includes(tenantData?.residentPrivateNetwork?.opStatus);

  if (!alreadySuspended) {
    // Loop guard: after this dispatch, alreadySuspended is true, so the SET_TENANT
    // watcher re-entry returns immediately without dispatching again.
    yield put(actions.setTenant({ ...(tenantData || {}), connectionStatus: 'SUSPENDED' }));
  }
}

export function* reconcileTenantSuspensionOnTenantChangeSaga() {
  const connectivityStatus = yield select(state => state.spectrumReady.status);
  yield* reconcileTenantSuspension(connectivityStatus);
}

export function* initGetSpectrumReadyStatusSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    yield put(actions.initGetSpectrumStatusStart());
    try {
        const response = yield axios.post(
        '/specSuspendStatus',
        {
          rMac: rMac,
          bToken: token,
          sessionToken: sessionToken
        }
        );

      if (response.data.status === 500) {
        yield put(actions.getSpectrumStatusFailed(response.data.error))
        return;
      }
      yield put(actions.setSpectrumStatus(response.data))
    } catch (error) {
      yield put(actions.getSpectrumStatusFailed(error.message))
    }
  }

}

export function* moveInSaga(action) {
 const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');

  if (sessionToken) {
    yield put(actions.initConnectivityStart());
    try {
      let response = {};
          response = yield axios.post(
            '/moveIn',
            { rMac:rMac,
              bToken: token,
              sessionToken:sessionToken }
          ).then(res=>{
            //console.log('is res', res.data)
            let parsedData = JSON.parse(res.data.data)
            //console.log('MoveIn parsed data', parsedData)
            // sessionStorage.setItem("vendorModel", parsedData.model);
            return parsedData

          })
      yield //console.log('gonna set conn', response.status)
      yield put(actions.setConnectivity(response.status));
      yield put(actions.changeSettingsSuccess());
    } catch (error) {
      yield put(actions.changeSettingsFailed());
    }
} else {
  //console.log('NO TOKEN')
 }


}


export function* moveOutSaga(action) {
  //console.log('moveout saga')
 const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');

  if (sessionToken) {
    yield put(actions.initConnectivityStart());
    try {
      let response = {};
          response = yield axios.post(
            '/moveOut',
            { rMac:rMac,
              bToken: token,
              sessionToken:sessionToken }
          ).then(res=>{
            //console.log('is res', res.data)
            let parsedData = JSON.parse(res.data.data)
            //console.log('moveout parsed data', parsedData)
            // sessionStorage.setItem("vendorModel", parsedData.model);
            return parsedData

          })
      yield //console.log('gonna set conn', response.status)
      yield put(actions.setConnectivity(response.status));
      yield put(actions.changeSettingsSuccess())
      let timerStart = Date.now()
      yield put(actions.restarting(timerStart));
      yield put(actions.checkWan(rMac,token, sessionToken, packageJson.firstCheckWanWait, timerStart));
    } catch (error) {
      yield put(actions.changeSettingsFailed());
    }
} else {
  //console.log('NO TOKEN')
 }


}

